export enum BookingPackageKartingEnum {
    WithKarting = "with_karting",
    WithoutKarting = "without_karting",
}